import {MantineProvider} from '@mantine/core'
import {DatesProvider} from '@mantine/dates'
import {Notifications} from '@mantine/notifications'
import {QueryClientProvider} from '@tanstack/react-query'
import {createRootRoute, Outlet} from '@tanstack/react-router'

import {queryClient} from '../api/query-client'
import {AuthProvider} from '../auth/auth-context'
import {ClientErrorFallback} from '../error-boundary/client-error-fallback'
import {cssVariablesResolver, datesSettings, theme} from '../theme'

export const Route = createRootRoute({
    component: RootComponent,
    errorComponent: ClientErrorFallback,
})

function RootComponent() {
    return (
        <MantineProvider theme={theme} cssVariablesResolver={cssVariablesResolver}>
            <DatesProvider settings={datesSettings}>
                <Notifications position="bottom-right" />
                <QueryClientProvider client={queryClient}>
                    <AuthProvider>
                        <Outlet />
                    </AuthProvider>
                </QueryClientProvider>
            </DatesProvider>
        </MantineProvider>
    )
}
